import { DefaultLayout, WebLayout } from "../layouts";
import Dashboard from "../pages/Dashboard/Dashboard";
import ViewOrganization from "../pages/Organization/ViewOrganization";
import UserOrganizations from "../pages/UserPages/UserOrganizations/UserOrganizations";
import Homepage from "../layouts/Homepage";
import Budgets from "../pages/Budget/Budget";
import UserList from "../pages/Users/UserList";
import Reports from "../pages/Reports/Reports";
import DataElements from "../pages/DataElements/DataElements";
import ConfirmDeleteModal from "../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import ImageSelect from "../components/Comman/ImageSelect/ImageSelect";
import SubmissionStatus from "../pages/SubmissionStatus/SubmissionStatus";
import DataReviewListing from "../pages/DataReview/DataReviewListing";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "../pages/AboutUs/AboutUs";
import Setting from "../pages/Settings/Setting";
import ViewDataElements from "../pages/DataElements/ViewDataElements";
import ViewUser from "../pages/Users/ViewUser";
import AssignElements from "../pages/LeaderAssignElements/AssignElements";
import UserDataEntries from "../pages/UserPages/UserDataEntries";
import { Updateaccountdetails } from "../pages/Acount/Updateaccountdetails";

export const globalLeaderRoutes = [
  {
    path: "/",
    exact: true,
    layout: WebLayout,
    component: Homepage,
  },
  {
    path: "/leader/dashboard",
    exact: true,
    layout: DefaultLayout,
    component: Dashboard,
  },
  {
    path: "/leader/budgets",
    exact: true,
    layout: DefaultLayout,
    component: Budgets,
  },
  {
    path: "/leader/users",
    exact: true,
    layout: DefaultLayout,
    component: UserList,
  },
  {
    path: "/leader/view-organization/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewOrganization,
  },
  {
    path: "/leader/organizations",
    exact: true,
    layout: DefaultLayout,
    component: UserOrganizations,
  },

  {
    path: "/leader/reports",
    exact: true,
    layout: DefaultLayout,
    component: Reports,
  },
  {
    path: "/leader/data-elements",
    exact: true,
    layout: DefaultLayout,
    component: DataElements,
  },
  {
    path: "/leader/modal",
    exact: true,
    layout: DefaultLayout,
    component: ConfirmDeleteModal,
  },
  {
    path: "/leader/select",
    exact: true,
    layout: DefaultLayout,
    component: ImageSelect,
  },
  {
    path: "/leader/submission-status",
    exact: true,
    layout: DefaultLayout,
    component: SubmissionStatus,
  },
  {
    path: "/leader/data-review",
    exact: true,
    layout: DefaultLayout,
    component: DataReviewListing,
  },
  {
    path: "/privacy",
    exact: true,
    layout: DefaultLayout,
    component: PrivacyPolicy,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    layout: DefaultLayout,
    component: AboutUs,
  },

  {
    path: "/settings",
    exact: true,
    layout: DefaultLayout,
    component: Setting,
  },
  {
    path: "/leader/view/data-element/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewDataElements,
  },
  {
    path: "/leader/view/user/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewUser,
  },
  {
    path: "/leader/assign-element",
    exact: true,
    layout: DefaultLayout,
    component: AssignElements,
  },
  {
    path: "/leader/data-entry",
    exact: true,
    layout: DefaultLayout,
    component: UserDataEntries,
  },

  {
    path: "/profile",
    exact: true,
    layout: DefaultLayout,
    component: Updateaccountdetails,
  },
];
